import { useState } from 'react';
import { IconButton, Popover } from '@material-ui/core';
import Utils from '@/common/utils/utils';
import { onChangeViewSelectedHelpdeskList } from '@/component/ticketList/handler/HelpDeskViewHandler';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';

export default function SeemoreViewHelpdeskList(props) {
    // item menu tabs
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const [clickTimeout, setClickTimeout] = useState(null);
    // end item menu tabs

    const {
        listViewShow,
        viewSelected,
        setViewSelected,
        viewStructure,
        setViewStructure,
        setTriggerSearch,
        element,
        nodeListView,
        getVisibleWidth
    } = props;

    const onClickActiveTabChange = (e, ticketId, item) => {
        onChangeViewSelectedHelpdeskList(
            item,
            viewSelected,
            setViewSelected,
            viewStructure,
            setViewStructure,
            setTriggerSearch,
            clickTimeout,
            setClickTimeout
        );
        setAnchorEl(null);
        
        // Delay to ensure DOM and CSS (fullname display) are updated before scrolling
        setTimeout(() => {
            let containerRect = element.getBoundingClientRect();
            let posElem = [];
            for (let i = 0; i < nodeListView.length; i++) {
                let ids = listViewShow[i].id;
                // Gets the amount of pixels currently visible within the container
                let visiblePageWidth = getVisibleWidth(nodeListView[i]);
                posElem.push({ id: ids, pos: visiblePageWidth });
            }

            let currentIndex = Utils.findIndexInArrayById(viewSelected?.id, posElem);
            let nextIndex = Utils.findIndexInArrayById(ticketId, posElem);

            let isRightPosItem = nextIndex - currentIndex > 0 ? true : false;

            if (isRightPosItem) {
                if (posElem[nextIndex].pos.left + posElem[nextIndex].pos.width > containerRect.width) {
                    element.scrollLeft +=
                        posElem[nextIndex].pos.width -
                        (containerRect.width - posElem[nextIndex].pos.left);
                }
            } else {
                if (posElem[nextIndex].pos.left + posElem[nextIndex].pos.width <= containerRect.width) {
                    element.scrollLeft += posElem[nextIndex].pos.left;
                }
            }
            
            // Ensure selected view is scrolled into viewport (center if possible)
            const viewElement = document.querySelector(`[data-view-id="${ticketId}"]`);
            if (viewElement) {
                const elementRect = viewElement.getBoundingClientRect();
                const scrollLeft = element.scrollLeft + 
                    (elementRect.left - containerRect.left) - 
                    (containerRect.width / 2) + 
                    (elementRect.width / 2);
                
                element.scrollTo({
                    left: scrollLeft,
                    behavior: 'smooth'
                });
            }
        }, 100); // Delay to ensure CSS fullname is applied
    };

    return (
        <div className="gNav-tabs">
            <IconButton
                className="itemNav"
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <img src="/assets/image/icon-navTabs.svg" alt="" />
            </IconButton>
            <Popover
                className="navTabs-drop navTabs-drop--changePd"
                id={open ? 'simple-popover' : undefined}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
            >
                <ul className="list-view-seemore">
                    {listViewShow.map(item => {
                        let viewNameObj = Utils.convertJSONDataToObject(item.name);
                        let viewName = viewNameObj['jp'].text;
                        return (
                            <li
                                key={item.id}
                                onClick={e => onClickActiveTabChange(e, item.id, item)}
                                className={`${viewSelected?.id === item.id && 'item-active-li'}`}
                            >
                                <OverFlowTooltipWithTabsMui value={viewName} />
                            </li>
                        );
                    })}
                </ul>
            </Popover>
        </div>
    );
}
